// SYNCED FROM: VidaReactNative/src/features/AddressVerification/utils/compareAddresses.ts
// Keep in sync. See SYNC.md.
import { ADDRESS_FIELDS } from '../types';
import type { Address } from '../types';

/**
 * Strict per-field equality. Both addresses are expected to be trimmed first.
 * Casing differences and abbreviations count as a difference.
 */
export const areAddressesEqual = (a: Address, b: Address): boolean => {
  return ADDRESS_FIELDS.every((field) => (a[field] ?? '') === (b[field] ?? ''));
};
